import { useEffect, useState } from 'react';
import './App.css';
import Pinpad from './components/Pinpad'
import SessionForm from './components/SessionForm'
function App(props) {
  const [stage, setStage] = useState("");
  const [emailStored, setEmailStored] = useState(false);
  useEffect(() => {
    const params = new URLSearchParams(window.location.search)
    let s = params.get('stage')
    setStage(s)
    if(getSessionEmail()){
      setEmailStored(true);
    }
  }, [])

  const setSessionEmail = (email) => {
    localStorage.setItem("email", JSON.stringify(email))
    setEmailStored(true)
  }
  const getSessionEmail = () => localStorage.getItem("email")
  const content = () => {
    if(!emailStored){
      return (
        <SessionForm mission={props.mission} onEnter={setSessionEmail}/>
      )
    }else{
      return (
        <Pinpad mission={props.mission} stage={stage}/>
      )
    }
  }
  return (
    <div className="App">
      <header className="App-header">
        <img alt="mdf commerce" className="logo" src="https://www.mdfcommerce.com/images/2020_logo_mdf.svg"/>
      </header>
	  
      {content()}

    </div>
  );
}

export default App;
